import React from 'react'

import { IDataType } from './hooks/useVariables'

const VariablesContext = React.createContext<IDataType>({})

// FIXME: remove after removing date filter
// should refactor https://github.com/ParedEngineering/resumes/pull/1700
export default VariablesContext
